import { call, put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { requestPuppy } from '@wix/da-http-client';
import { actions, selectors } from '../../Stream';
import {
  getCurrentMediaSource,
  getCurrentStreamId,
  getCurrentGallection,
  getCurrentSubfolderId,
  getGrusername,
} from '../selectors';
import type { Action } from 'redux-actions';
import type { MoveDeviationToPositionPayload } from '../actions';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
import { MediaSourceType } from '../types';
import type { PapiRequestDaSharedGallectionFoldersUpdateDeviationOrder } from '@wix/da-papi-types';
import { getGallectionType } from '../helpers';

function* moveDeviationToPosition(
  action: Action<MoveDeviationToPositionPayload>
): SagaIterator {
  const { deviation, position, moveType } = action.payload!;
  const {
    streamId,
    currentMediaSource,
    currentGallection,
    currentSubfolderId,
    username,
  }: {
    streamId: ReturnType<typeof getCurrentStreamId>;
    currentMediaSource: ReturnType<typeof getCurrentMediaSource>;
    currentGallection: ReturnType<typeof getCurrentGallection>;
    currentSubfolderId: ReturnType<typeof getCurrentSubfolderId>;
    username: string;
  } = yield select(state => ({
    streamId: getCurrentStreamId(state),
    currentMediaSource: getCurrentMediaSource(state),
    currentGallection: getCurrentGallection(state),
    currentSubfolderId: getCurrentSubfolderId(state),
    username: getGrusername(state),
  }));

  const isFetching = yield select(selectors.isFetching, streamId);

  if (!moveType || moveType === 'streamOnly') {
    if (currentMediaSource !== MediaSourceType.CUSTOM_SET && isFetching) {
      return;
    }
    yield put(
      actions.moveItem({
        streamId,
        item: getDeviationEntityId(deviation),
        position,
      })
    );
  }

  if (currentMediaSource === MediaSourceType.CUSTOM_SET) {
    return;
  }

  if (!moveType || moveType === 'papiOnly') {
    if (!currentGallection) {
      return;
    }

    const data: PapiRequestDaSharedGallectionFoldersUpdateDeviationOrder = {
      username,
      type: getGallectionType(currentGallection) ?? 'collection',
      folderid: currentSubfolderId || currentGallection.folderId,
      deviationid: deviation.deviationId,
      position,
    };

    yield call(requestPuppy, {
      method: 'post',
      url: 'gallection/folders/update_deviation_order',
      data,
    });
  }
}

export default moveDeviationToPosition;
